import { AscButton } from "@ascendnow/ascend-components";
import { BullpenFinal } from "libs/components/src/components/AscIcons";
import styles from "./AscFinalCard.module.scss";

export default function AscFinalCard({
  type,
  onClick,
}: {
  type: string;
  onClick: () => void;
}) {
  return (
    <div className={styles.cardWrapper}>
      <svg
        width="262"
        height="314"
        viewBox="0 0 262 314"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g filter="url(#filter0_d_411_112473)">
          <rect x="20" width="222" height="300" rx="15" fill="white" />
        </g>
        <rect
          x="30"
          y="10"
          width="202"
          height="280"
          rx="10"
          fill="url(#paint0_linear_411_112473)"
        />
        <mask
          id="mask0_411_112473"
          style={{ maskType: "alpha" }}
          maskUnits="userSpaceOnUse"
          x="30"
          y="10"
          width="202"
          height="280"
        >
          <rect
            x="30"
            y="10"
            width="202"
            height="280"
            rx="10"
            fill="url(#paint1_linear_411_112473)"
          />
          <rect
            x="30"
            y="10"
            width="202"
            height="280"
            rx="10"
            fill="url(#paint2_linear_411_112473)"
          />
          <rect
            x="30"
            y="10"
            width="202"
            height="280"
            rx="10"
            fill="url(#paint3_linear_411_112473)"
          />
        </mask>
        <g mask="url(#mask0_411_112473)">
          <path
            d="M95.1647 87.15C43.7914 68.7476 -8.02917 84.5941 -27.5178 94.8176L-51 235.23C-44.1311 206.317 -1.73531 150.215 112.896 157.116C227.528 164.017 266.728 66.382 272 16.7019L253.789 5.67969C237.016 62.7079 159.381 110.153 95.1647 87.15Z"
            fill="white"
            fill-opacity="0.1"
          />
          <path
            d="M106.187 168.619C51.872 163.349 -30.0739 202.005 -49.5625 212.228L-45.2494 313.825C-46.2667 289.863 0.660645 182.804 115.292 189.705C229.924 196.605 243.725 121.175 255.227 110.153L248.038 87.6289C231.265 144.657 170.403 174.848 106.187 168.619Z"
            fill="white"
            fill-opacity="0.1"
          />
        </g>

        <path
          d="M91.5 29L93.3774 34.6226L99 36.5L93.3774 38.3774L91.5 44L89.6226 38.3774L84 36.5L89.6226 34.6226L91.5 29Z"
          fill="white"
          fill-opacity="0.8"
        />
        <path
          d="M107 21L108.001 23.9987L111 25L108.001 26.0013L107 29L105.999 26.0013L103 25L105.999 23.9987L107 21Z"
          fill="white"
          fill-opacity="0.8"
        />
        <path
          d="M192.5 226L194.377 231.623L200 233.5L194.377 235.377L192.5 241L190.623 235.377L185 233.5L190.623 231.623L192.5 226Z"
          fill="white"
          fill-opacity="0.8"
        />
        <path
          d="M183 218L184.001 220.999L187 222L184.001 223.001L183 226L181.999 223.001L179 222L181.999 220.999L183 218Z"
          fill="white"
          fill-opacity="0.8"
        />
        <defs>
          <filter
            id="filter0_d_411_112473"
            x="16"
            y="0"
            width="230"
            height="308"
            filterUnits="userSpaceOnUse"
            color-interpolation-filters="sRGB"
          >
            <feFlood flood-opacity="0" result="BackgroundImageFix" />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset dy="4" />
            <feGaussianBlur stdDeviation="2" />
            <feComposite in2="hardAlpha" operator="out" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
            />
            <feBlend
              mode="normal"
              in2="BackgroundImageFix"
              result="effect1_dropShadow_411_112473"
            />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="effect1_dropShadow_411_112473"
              result="shape"
            />
          </filter>

          {type === "internship" ? (
            <linearGradient
              id="paint0_linear_411_112473"
              x1="136.744"
              y1="-168"
              x2="136.744"
              y2="483.219"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-color="#61D5EE" />
              <stop offset="1" stop-color="#3CBB73" />
            </linearGradient>
          ) : (
            <linearGradient
              id="paint0_linear_411_112473"
              x1="136.744"
              y1="-168"
              x2="136.744"
              y2="483.219"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-color="#FEB45E" />
              <stop offset="1" stop-color="#F94182" />
            </linearGradient>
          )}
          <linearGradient
            id="paint1_linear_411_112473"
            x1="136.744"
            y1="-99.7945"
            x2="136.744"
            y2="483.219"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="#FEB45E" />
            <stop offset="1" stop-color="#F94182" />
          </linearGradient>
          <linearGradient
            id="paint2_linear_411_112473"
            x1="136.744"
            y1="-99.7945"
            x2="136.744"
            y2="483.219"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="#FEB45E" />
            <stop offset="1" stop-color="#F94182" />
          </linearGradient>
          <linearGradient
            id="paint3_linear_411_112473"
            x1="136.744"
            y1="-99.7945"
            x2="136.744"
            y2="483.219"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="#FEB45E" />
            <stop offset="1" stop-color="#F94182" />
          </linearGradient>
        </defs>
      </svg>
      {type === "internship" ? (
        <div className={styles.content}>
          <span className={styles.title}>You can now use the</span>
          <p className={styles.text}>The Edge</p>
          <p className={styles.text}>Job Board</p>
          <AscButton className={styles.btn} size="small" onClick={onClick}>
            Apply
          </AscButton>
        </div>
      ) : (
        <div className={styles.contentEnterPreunership}>
          <div className={styles.svgIcon}>
            <BullpenFinal />
          </div>

          <span className={styles.title}>Apply to </span>
          <span className={styles.title}>participate in the</span>
          <p className={styles.text}>The Edge Now Bullpen</p>

          <AscButton className={styles.btn} size="small" onClick={onClick}>
            Apply
          </AscButton>
        </div>
      )}
    </div>
  );
}
